import '../css/scss/app.scss';
import $ from 'jquery';
import featuredPanel from './featuredPanel';
import site from './site';

// Legacy modules expect jQuery on window.
window.$ = $;
window.jQuery = $;

// Auto-load sibling JS modules so new files in this directory are bundled.
import.meta.glob(['./*.js', '!./main.js'], { eager: true });

document.addEventListener('DOMContentLoaded', () => {
  site.init();
  featuredPanel.init();
});

const yearNode = document.querySelector('[data-year]');
if (yearNode) {
  yearNode.textContent = String(new Date().getFullYear());
}
